module.exports = __webpack_public_path__ + "static/media/arecor.94c133ed.jpg";